import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { academyApi } from "@/lib/academy";
import { BELT_COLORS, BELT_INK } from "@/lib/academy";

/** Homepage banner: the ninja sensei beside all eight belt levels and what each one teaches. */
export default function AcademyBanner() {
  const [belts, setBelts] = useState([]);
  useEffect(() => {
    academyApi.overview().then((d) => setBelts(d.belts || [])).catch(() => {});
  }, []);

  return (
    <section className="academy-banner" data-testid="academy-banner">
      <div className="wrap academy-banner-grid">
        <div className="academy-banner-copy">
          <span className="eyebrow">SOLAR BLACK BELT ACADEMY</span>
          <h2>Earn your belts. Know solar like a sensei.</h2>
          <p className="lead">
            Free, self-paced classes on commercial solar and Tesla Powerwall — 24 lessons, 8 belts, from your
            first energy lesson to the Black Belt capstone and oral defense.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 18 }}>
            <Link className="btn lime" data-testid="academy-banner-cta" to="/academy">Train at the academy ↗</Link>
            <a className="btn light" href="/academy-assets/solar-black-belt-academy-syllabus.pdf" target="_blank" rel="noopener noreferrer">Download the syllabus</a>
          </div>
          <p className="micro" style={{ marginTop: 12 }}>
            Internal company credential issued by Coastal Energy after verified assessment — not a Tesla
            certification, not NABCEP, not a license. Completion enables hiring consideration; never a job promise.
          </p>
        </div>
        <div className="academy-banner-figure">
          <img src="/academy-assets/ninja-stand.jpg" alt="Roi Solar, the academy's ninja sensei, welcoming students" loading="lazy" data-testid="academy-banner-ninja" />
        </div>
        <div className="academy-belt-list" data-testid="academy-belt-list">
          {belts.map((b) => (
            <Link to={`/academy/belts/${b.id}`} key={b.id} className="academy-belt-row" data-testid={`academy-belt-${b.id}`}>
              <img src={b.scene} alt={`${b.name} Belt class scene`} loading="lazy" />
              <span className="academy-belt-chip" style={{ background: BELT_COLORS[b.name], color: BELT_INK[b.name] }}>{b.name} Belt</span>
              <span className="academy-belt-know">{b.summary}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
